// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'form-rules-import-setup',
    templateUrl: './form-rules-import-setup.component.html',
    standalone: false,
})
export class FormRulesImportSetupComponent implements OnInit {
    @Input() step: any;
    @Input() data: any;
    @Input() selected: any;

    options: any[] = [];

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.options = [];
        this.selected.match = null;
        this.selected.match_rule = null;
        this.selected.exclude = null;
        this.selected.text = null;
        this.setupOptions();
        this.setupSelected();
    }

    private setupOptions (): void {
        for (let i = 0; i < this.data.data[0].length; i++) {
            this.options.push({ name: this.data.data[0][i], value: i.toString() });
        }
    }

    private setupSelected (): void {
        for (let i = 0; i < this.options.length; i++) {
            switch (this.options[i].name.toLowerCase()) {
                case 'match':
                    this.selected.match = this.options[i].value;
                    break;

                case 'match_rule':
                    this.selected.match_rule = this.options[i].value;
                    break;

                case 'text':
                    this.selected.text = this.options[i].value;
                    break;

                case 'exclude':
                    this.selected.exclude = this.options[i].value;
                    break;
            }
        }
    }
}
